(function () {
    'use strict';

    angular.module("imApp").factory("batchDelControlService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1645,
                    parameters: parms || {}
                });
            },
            listControls: function (parms) {
                return $ihttp.post({
                    method: 1603,
                    parameters: parms || {}
                });
            },
            listSkus: function (parms) {
                return $ihttp.post({
                    method: 1647,
                    parameters: parms || {}
                });
            },
            approveControl: function (setting) {
                return $ihttp.post({
                    method: 1646,
                    parameters: setting
                });
            }
        };

        return service;
    }]);
})();
